import { SignInButton } from "@clerk/clerk-react";
import { Button } from "@/components/ui/button";
import { Pizza } from "lucide-react";

const LoginPage = () => {
  return (
    <div className="flex min-h-screen flex-col bg-background px-safe pt-safe pb-safe">
      <main className="flex flex-1 items-center justify-center py-12">
        <div className="w-full max-w-sm">
          {/* Brand mark — matches the "Order Portal" identity in the app shell. */}
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-radius-card bg-action-primary text-action-primary-foreground">
              <Pizza className="h-6 w-6" />
            </div>
            <span className="text-xl font-bold text-action-primary">Order Portal</span>
          </div>

          <div className="mt-8">
            <h1 className="text-2xl font-bold text-foreground sm:text-3xl">
              Welcome back
            </h1>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              Manage tonight's orders, customer texts, and your regulars, all from
              one counter.
            </p>
          </div>

          <SignInButton fallbackRedirectUrl="/">
            <Button className="mt-8 h-12 w-full text-base">
              Sign in to continue
            </Button>
          </SignInButton>

          <p className="mt-6 text-xs text-muted-foreground">
            Staff access only. Ask the owner if you need an account.
          </p>
        </div>
      </main>
    </div>
  );
};

export default LoginPage;
